/**
 * The `value` reported on `booking_complete` when the booking carries a
 * submitted `total_price` — the revenue figure marketing computes CAC from.
 *
 * `total_price` means a different thing per path, verified against production
 * booking 650f8918 and the voucher-billing-consistency e2e traces:
 *
 *  - Pay later submits it NET of the voucher (Pro pay-later stored 339,900 =
 *    354,900 list − the 15,000 cap). It passes through unchanged.
 *  - A membership checkout submits the PRE-discount member subtotal (650f8918:
 *    stored 62,600 = the Stripe invoice subtotal). Reporting that verbatim
 *    over-counted every discounted signup by the full discount, so here the
 *    voucher comes off — through voucherDiscountCents, the same shared helper
 *    every display surface uses (referral cap + whole-franc rounding), so
 *    analytics introduces no third arithmetic.
 *
 * The path signal is membershipSignupSource's verdict, not raw store fields —
 * see membershipSignup.ts for why.
 */
import { voucherDiscountCents } from "./voucherDiscount";
import type { Discount } from "@/stores/bookingStore";
import type { MembershipSignupSource } from "./membershipSignup";

export function bookingCompleteValueCents(opts: {
  /** The submitted total_price, in cents. */
  storedTotalCents: number;
  discount: Discount | null;
  membershipSignup: MembershipSignupSource;
}): number {
  const { storedTotalCents, discount, membershipSignup } = opts;

  // Every non-signup path already submitted the net figure.
  if (membershipSignup === "none" || !discount) return storedTotalCents;

  return Math.max(
    0,
    storedTotalCents - voucherDiscountCents(discount, storedTotalCents),
  );
}
